//'use strict';

// Bootsrap
import 'bootstrap';

import './modules/fetch';
import './modules/has-many';
import './modules/observer';

// Theme
import '../../src/js/bootstrap';
import './modules/tooltip';
import './modules/dropdown';
import './modules/validation';
import './modules/table';
import './modules/wizard';
import './modules/show-password';
import './modules/tab-link';

// Vendors
import './modules/vendors/flatpickr';
import './modules/vendors/dragula';
import './modules/vendors/dropzone';
import './modules/vendors/tom-select';
import './modules/vendors/quill';
import './modules/vendors/sortable';

// Vendors
import '../../src/js/vendors/list';
import '../../src/js/vendors/fullcalendar';
import '../../src/js/vendors/gumshoejs';
import '../../src/js/vendors/picmo';
//import '../../src/js/vendors/quill';
import '../../src/js/vendors/inputmask';
import '../../src/js/vendors/zxcvbn';
import '../../src/js/vendors/clipboard';
import '../../src/js/vendors/highlightjs';


import jQuery from 'jquery';
import {v4 as uuid} from 'uuid';

window.$ = jQuery;
window.$_ = document.querySelector.bind(document);
window.$__ = document.querySelectorAll.bind(document);
window.uuid = uuid;
